import Tile from '../Tile/Tile';

export default function ParticipantCamera({ participant }) {
  if (!participant) return <Tile empty />;
  return <Tile id={participant.session_id} isLocal={participant.local} />;
}
